import styled from 'foundations-theming/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { getDocumentsUrl, getMeetingsUrl } from 'hubspot-prosemirror/draft-transplant/utils/links';
import { H7 } from 'foundations-components/transitional/components/H7';
import { Flex } from 'foundations-components/components/Flex';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Divider = styled.div.withConfig({
  displayName: "InlineInsertHeader__Divider",
  componentId: "hq4gc2-0"
})(["background-color:", ";block-size:24px;margin-inline:", ";inline-size:1px;"], ({
  theme
}) => theme.color['border-core-default'], ({
  theme
}) => theme.space['300']);
const MediaHeader = styled.div.withConfig({
  displayName: "InlineInsertHeader__MediaHeader",
  componentId: "hq4gc2-1"
})(["align-items:center;display:flex;justify-content:space-between;width:100%;"]);
const MANAGE_URL_MAP = {
  MEETINGS: getMeetingsUrl(),
  DOCUMENTS: getDocumentsUrl()
};
const getHeaderText = type => {
  if (type === 'MEETINGS') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.insertHeader.insertItem.MEETINGS"
    });
  }
  if (type === 'DOCUMENTS') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.insertHeader.insertItem.DOCUMENTS"
    });
  }
  return null;
};
const InlineInsertHeader = props => {
  const {
    onBackClick,
    onClickManageButton,
    selectedType
  } = props;
  if (!selectedType) {
    return null;
  }
  const manageUrl = MANAGE_URL_MAP[selectedType];
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    marginInline: "500",
    marginBlockStart: "500",
    children: [/*#__PURE__*/_jsx(IconButton, {
      onClick: onBackClick,
      use: "link",
      "data-test-id": "insert-menu-back-button",
      children: /*#__PURE__*/_jsx(LeftIcon, {})
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(MediaHeader, {
      children: [/*#__PURE__*/_jsx(H7, {
        marginBlockEnd: "0",
        children: getHeaderText(selectedType)
      }), /*#__PURE__*/_jsx(Button, {
        external: true,
        href: manageUrl,
        size: "extra-small",
        use: "tertiary-light",
        onClick: onClickManageButton,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "hubspot-prosemirror.insertHeader.manageContentLink"
        })
      })]
    })]
  });
};
export default InlineInsertHeader;